import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ModelMaintenance } from '../model-mantenance';
import { BrandBuilder } from './brand.builder';
import { MaintenanceTaskBuilder } from './maintenance-task.builder';

export class ModelMaintenanceBuilder {
  static fromJson(json) {
    return (json)
      ? new ModelMaintenance(
        json.hash,
        json.name,
        parseNumber(json.reference),
        parseNumber(json.order),
        json.active,
        json.ip,
        json.readMode,
        json.serie,
        json.imagePath,
        BrandBuilder.fromJson(json.brand),
        MaintenanceTaskBuilder.fromJson(json.lastMaintenance),
        MaintenanceTaskBuilder.fromJson(json.nextMaintenance)
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ModelMaintenanceBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/model-maintenance.builder.ts